
export default function capitailzer(str) {
    if (typeof str !== 'string') return str
    return str.charAt(0).toUpperCase() + str.slice(1);
}

export function cleanEnglishOnly(value) {
  return value.replace(/[^a-zA-Z0-9 _\-/:,()'.]/g, "");
}